import { AuthProvider } from '@sdk/authentication/AuthContext';
import ToastComponent from '@sdk/common/toast/ToastComponent';
import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import EditTimesheetModal from '@web/timesheets/EditTimesheetModal/EditTimesheetModal';
import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';

const EditTimesheetModalAngular = ({
  Authentication,
  PersonaCollection,
  shift,
  isTimesheetEditActive = false,
  onClose,
  onSave,
}) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <PersonaCollectionContext.Provider value={PersonaCollection}>
          <QueryClientProvider>
            <EditTimesheetModal
              shift={shift}
              isVisible={isTimesheetEditActive}
              onClose={onClose}
              onSave={onSave}
            />
          </QueryClientProvider>

          <ToastComponent />
        </PersonaCollectionContext.Provider>
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: EditTimesheetModalAngular,
  dependencies: ['Authentication', 'PersonaCollection'],
  bindings: {
    shift: '<',
    isTimesheetEditActive: '<',
    onClose: '&',
    onSave: '&',
  },
};
